import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Materia } from '../../../models/materia';
import { MateriaService } from '../../../services/materia.service';
import { HomeService } from '../../../services/home.service';
import { TemaService } from '../../../services/tema.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  public materia: Materia;
  public home: any;
  public temas: any;
  public termo: string = '';

  public isTemaLoaded: boolean = false;

  formSearch = new UntypedFormGroup({});

  constructor(
    private materiaService: MateriaService,
    private homeService: HomeService,
    private temaService: TemaService,
    private router: Router
  ) {}

  ngOnInit() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('home-page');
    }

    this.getFirstMateria();
    this.getHomeInfo();
    this.getTemas();
    this.createForm();
  }

  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('home-page');
    }
  }

  getFirstMateria() {
    this.materiaService.getFirst().subscribe((mat: any) => {
      this.materia = mat;
    });
  }

  createForm() {
    this.formSearch = new UntypedFormGroup({
      termo: new UntypedFormControl(this.termo, Validators.required),
    });
  }

  submitForm() {
    this.termo = this.formSearch.value.termo;
    if (this.formSearch.invalid) return;
    this.router.navigate(['/pesquisa/' + this.termo]);
  }

  getHomeInfo() {
    this.homeService.get().subscribe((home: any) => {
      this.home = home;
    });
  }
  getTemas() {
    this.temaService.getMenu().subscribe((res: any) => {
      this.temas = res;
      this.isTemaLoaded = true;
    });
  }
}